function autotraceItemFields() {
  return {
    title: '',
    address: [],
    firstFilter: {
      address: [],
    },
    coin: '',
    token: undefined,
    sendMatch: [{
      unhosted: true,
    }, {
      known: true,
    }],
    channel: [],
    tx_hash: [],
    direction: 1,
  }
}

export { autotraceItemFields }
